import {filter, ListIterateeCustom} from 'lodash';
import {useMemo} from 'react';

import {useObservable} from 'hooks';
import {OnlineSession} from 'interfaces';
import {onlineSessionsStore} from 'services';

export function useOnlineSessions(predicate?: ListIterateeCustom<OnlineSession, boolean>) {
    const {sessions} = useObservable(onlineSessionsStore);
    const filtered = useMemo(() => filter(sessions, predicate), [predicate, sessions]);
    const filteredCount = useMemo(() => filtered.length, [filtered]);
    return {sessions: filtered, count: filteredCount};
}